module.exports = __webpack_public_path__ + "static/media/size1.79b85008.svg";